(function () {
  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }

    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'absolute';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
    return Promise.resolve();
  }

  function bindCopyButtons(root) {
    root.querySelectorAll('[data-copy-promo-code]').forEach(function (button) {
      if (button.dataset.promoCopyBound === 'true') return;
      button.dataset.promoCopyBound = 'true';

      button.addEventListener('click', function () {
        const code = button.dataset.copyPromoCode;
        if (!code) return;

        copyText(code).then(function () {
          const label = button.querySelector('.product-form__checkout-promo-copy-text');
          const originalText = label ? label.textContent : 'Copy';

          button.classList.add('is-copied');
          if (label) label.textContent = 'Copied!';

          window.setTimeout(function () {
            button.classList.remove('is-copied');
            if (label) label.textContent = originalText;
          }, 2000);
        });
      });
    });
  }

  function init() {
    bindCopyButtons(document);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', function (event) {
    bindCopyButtons(event.target);
  });
})();
